const HomeNavbarWrapper = ({ location, children }) => {
  return location.pathname.split("/")[1] === "home" ? children : <></>;
};

const NotDefinedNavbarWrapper = ({ location, children }) => {
  return location.pathname.split("/")[1] !== "home" &&
    location.pathname.split("/")[1] !== "post-install-page" &&
    location.pathname.split("/")[1] !== "config-page" ? (
    children
  ) : (
    <></>
  );
};

export { NotDefinedNavbarWrapper, HomeNavbarWrapper };
